import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { trackPageView } from '../lib/analytics';

/** Top-level layout: logs a GA4 page view on navigation. */
export function RootLayout() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return <Outlet />;
}
